import React from 'react'
import ReactDOM from 'react-dom/client'
import MainRouter from './main/routes/router'
import reportWebVitals from './reportWebVitals'
import 'index.css'
import 'materialize-css/dist/css/materialize.min.css'
import 'react-toastify/dist/ReactToastify.css'

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
)

root.render(
  <React.StrictMode>
    <MainRouter />
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
